export const PREVIOUS_URL_KEY = 'previous_url'
export const LOGIN_URL = '/login'
